var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-empty", {
    style: { height: _vm.height + "px" },
    attrs: {
      image: _vm.noData,
      "image-size": 150,
      description: _vm.description,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }